import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useParams } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient } from '../helpers/Helpers.js';

export default function DateDettagli() {

    const { id } = useParams();
    const client = getWebClient();
    const navigate = useNavigate();

    const [labels, setLabels] = useState();
    const [model, setModel] = useState({ id: uuidv4(), nome: '' });
    const [deleteButton, setDeleteButton] = useState('');

    useEffect(() => {

        if (id === 'new') {

            setLabels({
                "title": "Creazione nuova data",
                "submitButtonText": "Crea la data",
            });

            setModel({
                id: uuidv4(),
                progressivo: '',
                dataISO: 'YYYY-MM-DDT00:00:00',
                dataTestuale: ''
            });


        } else {

            setLabels({
                "title": "Dettagli della data",
                "submitButtonText": "Modifica la data",
            });

            setDeleteButton(<button type="button" className="btn btn-primary" style={{ marginTop: 40, marginLeft: 10 }} onClick={handleDeleteStep1}>Elimina la data</button>);

            const dateGetPromise = client.get(`/api/date/${id}`).then((response) => {
                setModel(response.data);
            });

            Promise.all([dateGetPromise]).catch(function (err) {
                console.log(err);
            });

        }

    }, []);

    const handleDeleteStep1 = (event) => {

        setDeleteButton(
            <div className="btn-group" role="group" style={{ marginTop: 40, marginLeft: 10 }}>
                <button type="button" className="btn btn-primary" onClick={handleDeleteUndo}>Annulla</button>
                <button type="button" className="btn btn-danger" onClick={handleDeleteStep2}>Procedi con l'eliminazione</button>
            </div>
        );

    }

    const handleDeleteStep2 = (event) => {

        client.delete(`/api/date/${id}`)
            .then(function (response) {
                navigate("/date");
            })
            .catch(function (error) {
                alert("Si sono verificati errori durante l'operazione di eliminazione. Riprovare in un secondo momento.");
            });

    }

    const handleDeleteUndo = (event) => {

        setDeleteButton(<button type="button" className="btn btn-primary" style={{ marginTop: 40, marginLeft: 10 }} onClick={handleDeleteStep1}>Elimina la data</button>);

    }

    if (labels === undefined || model === undefined) { return; }

    return (
        <>

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <h4>{labels.title}</h4>
            </div>

            <div className="container" style={{ marginBottom: 80 }}>

                <Formik

                    initialValues={model}
                    enableReinitialize="true"

                    validate={values => {

                        const errors = {};

                        document.getElementsByName('progressivo')[0].classList.remove("is-invalid")
                        document.getElementsByName('dataISO')[0].classList.remove("is-invalid")
                        document.getElementsByName('dataTestuale')[0].classList.remove("is-invalid")

                        if (!values.progressivo) {
                            errors.progressivo = <>Il campo Progressivo &egrave; richiesto</>;
                            document.getElementsByName('progressivo')[0].classList.add("is-invalid")
                        }

                        if (!values.dataISO) {
                            errors.dataISO = <>Il campo Data ISO &egrave; richiesto</>;
                            document.getElementsByName('dataISO')[0].classList.add("is-invalid")
                        }

                        if (!values.dataTestuale) {
                            errors.dataTestuale = <>Il campo Data testuale &egrave; richiesto</>;
                            document.getElementsByName('dataTestuale')[0].classList.add("is-invalid")
                        }

                        return errors;
                    }}

                    onSubmit={(values, { setSubmitting }) => {

                        if (id === 'new') {

                            client.post('/api/date', values)
                                .then(function (response) {
                                    navigate("/date");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        } else {

                            client.put('/api/date', values)
                                .then(function (response) {
                                    navigate("/date");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        }
                    }}
                >

                    {({ isSubmitting }) => (

                        <Form>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Id</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="id" readOnly="readonly" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Progressivo</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="number" name="progressivo" id="progressivo" />
                                    <ErrorMessage className="invalid-feedback" name="progressivo" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Data ISO</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="dataISO" id="dataISO" />
                                    <ErrorMessage className="invalid-feedback" name="dataISO" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Data testuale</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="dataTestuale" id="dataTestuale" />
                                    <ErrorMessage className="invalid-feedback" name="dataTestuale" component="div" />
                                </div>
                            </div>

                            <button className="btn btn-primary" style={{ marginTop: 40 }} type="submit" disabled={isSubmitting}>{labels.submitButtonText}</button>
                            {deleteButton}

                        </Form>

                    )}

                </Formik>


            </div>

        </>
    )
}
